module.exports = __webpack_public_path__ + "assets/8be96e661d6cc44ddb18f30a740ac029.svg";